import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { useApiClient } from '../../../../../lib/apiClient';

const GET_AUTOMATION_INSIGHTS_QUERY_KEY = 'get-automation-insights';

export const useGetAutomationInsights = ({
  queueId,
  enabled,
}: {
  queueId: number;
  enabled: boolean;
}) => {
  const api = useApiClient();

  return useQuery({
    queryKey: [GET_AUTOMATION_INSIGHTS_QUERY_KEY, queueId],
    queryFn: () => {
      return api.request(endpoints.queues.automationInsights(queueId));
    },
    select: data => ({
      ...data,
      documentBlockers: data.documentBlockers.filter(
        ({ blocker }) => blocker !== 'alternative_prediction'
      ),
    }),
    enabled,
    keepPreviousData: true,
  });
};
